module.exports = __webpack_public_path__ + "media/metronic/_theme/media/flags/062-namibia-924cfe119249c56f753d2d59b1979b9e.svg";